import type { FC } from 'react';
import React from 'react';

import { DropdownItem } from '@atlaskit/dropdown-menu';

import { TabItem } from './TabItem';
import type { SpaceSettingsNavigationQuery_webItemSections_WebSection_items_WebItem as SpaceSettingsNavigationQuery_webItemSections_items } from './__types__/SpaceSettingsNavigationQuery';

type ConditionalDropdownItemWrapperProps = {
	condition: boolean;
	children?: React.ReactNode;
};

export const ConditionalDropdownItemWrapper: FC<ConditionalDropdownItemWrapperProps> = ({
	condition,
	children,
}) => (condition ? <DropdownItem>{children}</DropdownItem> : <>{children}</>);

export type BaseTabsProps = {
	setWidth?: (width: number, index?: number) => void;
	createClickEvent: (clickedTab?: string | null, source?: string) => () => void;
	isDropdown: boolean;
};

type WebItemTabsProps = BaseTabsProps & {
	webItems: SpaceSettingsNavigationQuery_webItemSections_items[];
	innerNavigationWebItem?: SpaceSettingsNavigationQuery_webItemSections_items | null;
};

export const WebItemTabs: FC<WebItemTabsProps> = ({
	webItems,
	setWidth,
	createClickEvent,
	innerNavigationWebItem,
	isDropdown,
}) => (
	<>
		{webItems.map(({ completeKey, label, url, id }, index) => (
			<ConditionalDropdownItemWrapper key={completeKey} condition={isDropdown}>
				<TabItem
					key={completeKey}
					label={label}
					// We don't track state of these tabs from WebItems since they are all legacy
					// monolith pages, which require a full page reload on click
					isSelected={completeKey === innerNavigationWebItem?.completeKey}
					href={url ?? ''}
					onClick={createClickEvent(completeKey || id)}
					isDropdown={isDropdown}
					index={index}
					setWidth={setWidth}
					size={webItems.length}
				/>
			</ConditionalDropdownItemWrapper>
		))}
	</>
);
